module.exports = __webpack_public_path__ + "img/cns_printer_pc6.140bc4b8.png";